<template>
  <div class="article-panel-wrapper">
    <ArticleFontSizeModal :show-modal="showFontSizeModal" @closeFontSizeModal="closeFontSizeModal" />
    <ArticleSocialShareModal
      :show-modal="showSocialShareModal"
      :article="article"
      :article-path="articlePath"
      @closeSocialShareModal="closeSocialShareModal"
    />
    <div v-if="article && article.id" class="article-panel">
      <div class="article-panel-icon" @click="openFontSizeModal">
        <i class="material-icons">
          text_fields
        </i>
      </div>
      <div class="article-panel-icon" @click="openSocialShareModal">
        <i class="material-icons">
          share
        </i>
      </div>
    </div>
    <div v-if="panelMobileDisplay" :class="panelMobileClass" class="article-panel--mobile">
      <div class="article-panel-icon left" @click="openFontSizeModal">
        <i class="material-icons">
          text_fields
        </i>
      </div>
      <div class="article-panel-icon right" @click="openSocialShareModal">
        <i class="material-icons">
          share
        </i>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleFontSizeModal from '@/components/article/ArticleFontSizeModal'
import ArticleSocialShareModal from '@/components/article/ArticleSocialShareModal'

export default {
  name: 'ArticlePanel',
  components: {
    ArticleFontSizeModal,
    ArticleSocialShareModal
  },
  directives: {},
  props: {
    article: {
      type: Object,
      default: () => {
        return {}
      }
    },
    articlePath: {
      type: String,
      default: 'articles' // articles, periodicalArticles
    }
  },
  data() {
    return {
      showSocialShareModal: false,
      showFontSizeModal: false,
      debounceTimer: 0,
      scrollDirection: 'DOWN', // DOWN, UP
      pageYOffset: window.pageYOffset || 0
    }
  },
  computed: {
    panelMobileDisplay() {
      return (this.scrollDirection === 'UP' && this.pageYOffset > 128) || this.pageYOffset < 128
    },
    panelMobileClass() {
      return this.pageYOffset < 64 ? 'relative' : 'fixed'
    }
  },
  watch: {},
  created() {},
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  updated() {},
  methods: {
    openSocialShareModal() {
      this.showSocialShareModal = true
    },
    closeSocialShareModal() {
      this.showSocialShareModal = false
    },
    openFontSizeModal() {
      this.showFontSizeModal = true
    },
    closeFontSizeModal() {
      this.showFontSizeModal = false
    },
    onScroll(e) {
      this.scrollDirection = window.pageYOffset > this.pageYOffset ? 'DOWN' : 'UP'
      this.pageYOffset = window.pageYOffset
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

@keyframes slide-down {
  0% {
    transform: translateY(-64px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
@mixin article-panel-mobile($margin-horizontal) {
  .article-panel {
    display: none;
    &-icon {
      height: 24px;
      width: 24px;
      display: inline-block;
      margin: 10px 0px;
      position: absolute;
    }
    &-icon.left {
      left: $margin-horizontal;
    }
    &-icon.right {
      right: $margin-horizontal;
    }

    &--mobile.relative {
      position: relative;
      display: block;
      height: 44px;
      width: 100vw;
      padding: 0 36px;
      margin: 0 #{0 - $margin-horizontal};
      background-color: $grey-f3;
    }
    &--mobile.fixed {
      position: fixed;
      top: 0;
      left: 0;
      display: block;
      height: 44px;
      width: 100vw;
      padding: 0 36px;
      background-color: $grey-f3;
      z-index: 1;
      animation: slide-down 0.5s 0s 1 linear;
    }
  }
}

.article-panel {
  &-wrapper {
    height: 44px;
  }
  &--fixed,
  &--mobile {
    display: none;
  }

  position: fixed;
  left: 36px;
  top: 144px;
  width: 64px;
  &-icon {
    margin: 36px 0;
    font-size: 24px;
    text-align: left;
    color: $grey-9b;
    cursor: pointer;
  }
}

@media only screen and (min-width: 1440px) {
  // As same as default
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  // As same as default
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  @include article-panel-mobile(36px);
}

@media only screen and (max-width: 767.98px) {
  @include article-panel-mobile(24px);
}
</style>
